module.exports = __webpack_public_path__ + "static/media/check-double-solid.6f218d0b.svg";